/* eslint-disable no-new */
import axios from 'axios'
export default {
  methods: {
    /**
     * @param {Indicates types of the AXIOS call} method
     * @param {Indicates URL} url
     * @param {Parameters} model
     * * Returns result from API
     */
    $_executeApi (method, url, model) {
      return axios[method](url, model)
    },
    /**
     * @param { Refers to the API } url
     * * Get the single record
     */
    $_getSingleRecordHandler (url) {
      return this.$_executeApi('get', url)
    },
    /**
     * @param { refers to the API } url
     * @param { Parameters to the API } model
     * * SAVE || Update Action
     */
    $_saveUpdateHandler (urlVal, model, hideSnackbar) {
      return new Promise((resolve, reject) => {
        let method = model.id ? 'put' : 'post'
        let url = model.id ? `${urlVal}/${model.id}` : urlVal
        let text = model.id ? this.$t('message.common.updatedSuccess') : this.$t('message.common.addedSucess')
        this.$_executeApi(method, url, model)
          .then(response => {
            if (!hideSnackbar) this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: text })
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    }
  }
}
